// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `toolbar {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  z-index: 4;
}
toolbar.below {
  z-index: 2;
}
toolbar .mat-toolbar {
  position: relative;
  background: inherit !important;
  color: inherit !important;
  height: 45px !important;
}
toolbar .logo {
  display: flex;
  align-items: center;
}
toolbar .logo .logo-icon {
  width: 38px;
}
toolbar .user-button,
toolbar .notification-button,
toolbar .fuse-search-bar,
toolbar .language-button,
toolbar .chat-panel-toggle-button,
toolbar .quick-panel-toggle-button {
  min-width: 64px;
  height: 45px;
}
@media screen and (max-width: 599px) {
  toolbar .user-button,
  toolbar .notification-button,
  toolbar .fuse-search-bar,
  toolbar .language-button,
  toolbar .chat-panel-toggle-button,
  toolbar .quick-panel-toggle-button {
    height: 42px;
  }
}
toolbar .navbar-toggle-button {
  min-width: 56px;
  height: 45px;
}
toolbar .toolbar-separator {
  height: 50px;
  width: 1px;
}
@media screen and (max-width: 599px) {
  toolbar .toolbar-separator {
    height: 42px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layout/components/toolbar/toolbar.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AADJ;AAGI;EACI,UAAA;AADR;AAII;EACI,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;AAHR;AAKQ;EACI,WAAA;AAHZ;AAOI;;;;;;EAMI,eAAA;EACA,YAAA;AALR;ACGQ;EDLJ;;;;;;IAUQ,YAAA;EACV;AACF;AAEI;EACI,eAAA;EACA,YAAA;AAAR;AAGI;EACI,YAAA;EACA,UAAA;AADR;ACfQ;EDcJ;IAKQ,YAAA;EAAV;AACF","sourcesContent":["@import \"src/@fuse/scss/partials/breakpoints\";\n\ntoolbar {\n    position: relative;\n    display: flex;\n    flex: 0 0 auto;\n    z-index: 4;\n\n    &.below {\n        z-index: 2;\n    }\n\n    .mat-toolbar {\n        position: relative;\n        background: inherit !important;\n        color: inherit !important;\n        height: 45px !important;\n    }\n\n    .logo {\n        display: flex;\n        align-items: center;\n\n        .logo-icon {\n            width: 38px;\n        }\n    }\n\n    .user-button,\n    .notification-button,\n    .fuse-search-bar,\n    .language-button,\n    .chat-panel-toggle-button,\n    .quick-panel-toggle-button {\n        min-width: 64px;\n        height: 45px;\n\n        @include media-breakpoint('xs') {\n            height: 42px;\n        }\n    }\n\n    .navbar-toggle-button {\n        min-width: 56px;\n        height: 45px;\n    }\n\n    .toolbar-separator {\n        height: 50px;\n        width: 1px;\n\n        @include media-breakpoint('xs') {\n            height: 42px;\n        }\n    }\n}\n","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
